<template>
    <div v-click-outside="closeDropdown" class="select-custom" :class="{ 'is-active': isOpen }">
        <div class="select-custom__header" :class="{ 'has-label': hasLabel }" @click="toggleDropdown">
            <span v-if="!chekedOptionTitle" class="select-custom__header-placeholder">{{ placeholder }}</span>
            <span v-else>{{ chekedOptionTitle }} {{ unit }}</span>
        </div>
        <div class="select-custom__dropdown">
            <div
                v-for="(variant, index) in variants"
                :key="index"
                class="select-custom__option"
                @click="changeOption(variant)"
            >
                {{ variant.title }} {{ unit }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectCustom',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        hasLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Choose',
        },
        selected: {
            type: [String, null],
            default: null,
        },
        variants: {
            type: Array,
            default() {
                return [];
            },
        },
        name: {
            type: String,
        },
        group: {
            type: String,
        },
        unit: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        chekedOptionTitle: function () {
            const checkedOption = this.variants.filter((variant) => variant.value === this.model)[0];
            return typeof checkedOption === 'object' && checkedOption.title ? checkedOption.title : 0;
        },
    },
    created() {
        const selected = this.variants.filter((variant) => variant.value === this.selected)[0];
        if (selected) this.model = selected.value;
    },
    methods: {
        closeDropdown: function () {
            this.isOpen = false;
        },
        toggleDropdown: function () {
            this.isOpen = !this.isOpen;
        },
        changeOption(variant, event) {
            if (event) event.preventDefault();
            this.model = variant.value;
            this.toggleDropdown();
        },
    },
    watch: {
        modelValue: function (newValue) {
            this.$emit('update-field', {
                name: this.name,
                group: this.group,
                value: newValue,
            });
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/mixins';

.select-custom {
    position: relative;

    &:hover,
    &.is-active {
        z-index: 2;
    }

    &__header {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 1rem;
        color: #000000;
        font-size: 14px;
        line-height: 26px;
        background-color: #f5f6f6;
        cursor: pointer;

        &.has-label {
            padding: 2.25rem 4rem 0.75rem 2rem;
        }

        &-placeholder {
            opacity: 0.6;
        }

        &::after {
            @include icon-material(24px, 'expand_more');
            position: absolute;
            top: 1rem;
            right: 1rem;
            color: var(--action-secondary);
            transition: $transition-fast;

            .is-active & {
                transform: rotate(180deg);
            }
        }
    }

    &__dropdown {
        position: absolute;
        display: block;
        width: 100%;
        padding: 1rem 0;
        // border: 1px solid var(--action-neutral-medium);
        box-sizing: border-box;
        border-radius: 8px;
        color: var(--action-secondary);
        overflow: hidden;
        background: #f5f6f6;
        max-height: 45vh;
        overflow-y: auto;

        @include smooth-dropdown-hide(true) {
            transition: transform 0.15s ease-in, opacity 0.15s ease-in;
        }

        .is-active & {
            @include smooth-dropdown-show();
        }
    }

    &__option {
        padding: 0.5rem 2rem;
        font-size: 16px;
        line-height: 24px;
        transition: $transition-fast;

        &:hover {
            cursor: pointer;
            color: var(--text-main-inverted);
            background: var(--action-neutral-medium-hover);
        }
    }
}
</style>
